import React, { useContext } from "react";
import { connect } from "react-redux";
// import {useHistory} from "react-router-dom";
// import * as baselineService from "./baselineService";
import { Checkbox } from "../../view/Checkbox";
import { debug, deepCopy } from "../../utils";
import { BaselineStatus } from "../../vars";
import { TableContext } from "../../index";


function BaselineTableRow({ data, index, baselineRules }) {

    // const history = useHistory();
    const { config, setConfig } = useContext(TableContext);


    const getCircleType = () => {
        switch (data.status) {
            case BaselineStatus.SUCCESS:
                return "success";
            case BaselineStatus.FAILURE:
                return "danger";
            default:
                return "warning";
        }
    }


    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    const status = data.status.charAt(0).toUpperCase() + data.status.slice(1).toLowerCase();

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td>{data.ruleName}</td>
            <td>{data.hasBaselineScript}</td>
            <td>{data.severity}</td>
            <td>
                <div className="oct_status">
                    <span className={`oct_circle oct_bg-${getCircleType()}`} />
                    {status}
                </div>
            </td>
        </tr>
    );

}

function mapStateToProps(state) {
    debug("BaselineTableRow mapStateToProps", state);
    const baselinePage = state.baselinePage;
    return { baselineRules: baselinePage.baselineRules || [] };
}

export default connect(mapStateToProps)(BaselineTableRow);
